import React from "react";
import {
  Box,
  Button,
  Chip,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import { Add, Menu, MoreVert } from "@mui/icons-material";
import { HeaderStyle, StudyCard, studyCardContent } from "./style";
import { NoDataContainer } from "../Common/styles/table";
type Props = {
  formName: string;
  phaseData: any[];
  formsData: any[];
  selectedPhase: string;
  eventType?: string;
  openModal: (name: string) => void;
  handleMenuClick: (
    event: React.MouseEvent<HTMLElement>,
    menuData: any,
    name: string
  ) => void;
  type: any;
  canEdit: boolean;
  handlePreviewClick?: Function;
};

const Forms = ({
  formName,
  phaseData,
  formsData,
  selectedPhase,
  eventType,
  openModal,
  handleMenuClick,
  type,
  canEdit,
  handlePreviewClick,
}: Props) => {
  const title = formName
    ? type?.val !== "surveyPackage"
      ? `Forms of ${formName}`
      : `Surveys of ${formName}`
    : type?.val !== "surveyPackage"
    ? "Forms"
    : "Surveys";

  const emptyEntityLabel =
    type?.val === "survey"
      ? "survey"
      : type?.val === "visit"
        ? "visit"
        : type?.val === "repeated_data"
          ? "repeating data item"
          : "phase";

  return (
    <Box sx={{ ...StudyCard, flex: 2 }}>
      <Box sx={HeaderStyle}>
        <Typography
          variant="subtitle1"
          fontWeight="medium"
          sx={{
            flex: 1,
            minWidth: "0px",
          }}
          noWrap
          title={title}
        >
          {title} ({formsData?.length})
        </Typography>

        {/* <Typography variant="body1" fontWeight="medium">
          ({formsData?.length})
        </Typography> */}

        {phaseData?.length > 0 && selectedPhase && canEdit && (
          <Box sx={{ ml: "auto" }}>
            {formsData?.length > 1 && (
              <Button
                variant="outlined"
                startIcon={<Menu />}
                onClick={() => openModal("rearrangeForms")}
                sx={{ mr: 2 }}
              >
                Rearrange
              </Button>
            )}
            {eventType === "repeated_measure" && formsData?.length === 0 && (
              <Button
                variant="outlined"
                startIcon={<Add />}
                onClick={() => openModal("form")}
              >
                Add Form
              </Button>
            )}
            {eventType !== "repeated_measure" && (
              <Button
                variant="outlined"
                startIcon={<Add />}
                onClick={() => openModal("form")}
              >
                Add {type?.val !== "surveyPackage" ? "Form" : "Surveys"}
              </Button>
            )}
          </Box>
        )}
      </Box>

      <Divider sx={{ borderColor: "#E5E7EB" }} />

      <Box sx={studyCardContent}>
        {formsData?.length ? (
          formsData?.map((item: any) => {
            return (
              <Box
                key={item?.id}
                sx={{ paddingInline: 2, cursor: "pointer" }}
                onClick={() => {
                  if (handlePreviewClick) {
                    handlePreviewClick(item.formId);
                  }
                }}
              >
                <Box sx={{ paddingBlock: "4px" }}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      minHeight: "52px",
                    }}
                  >
                    <Box
                      sx={{
                        ml: "5px",
                        mr: "100px",
                        width: "80%",
                        display: "flex",
                        alignItems: "center",
                        gap: 1,
                        minWidth: 0,
                        flex: 1,
                      }}
                    >
                      <Typography
                        variant="body1"
                        fontWeight="regular"
                        sx={{
                          wordBreak: "break-word",
                          overflow: "hidden",
                          display: "-webkit-box",
                          WebkitLineClamp: 2,
                          WebkitBoxOrient: "vertical",
                          minWidth: 0,
                        }}
                      >
                        {item?.name || ""}
                      </Typography>
                      {type?.val === "surveyPackage" &&
                        item?.hasForms === false && (
                          <Chip
                            size="small"
                            sx={{
                              padding: "2px 8px",
                              backgroundColor: "#FEF3C7",
                              color: "#92400E",
                              fontWeight: "medium",
                              borderRadius: "8px",
                              fontSize: "12px",
                              flexShrink: 0,
                            }}
                            label="No forms"
                          />
                        )}
                    </Box>
                    {(canEdit || type?.val !== "surveyPackage") && (
                      <IconButton
                        sx={{ ml: "auto" }}
                        onClick={(e) => handleMenuClick(e, item, "form")}
                      >
                        <MoreVert />
                      </IconButton>
                    )}
                  </Box>
                </Box>
                <Divider sx={{ borderColor: "#E5E7EB" }} />
              </Box>
            );
          })
        ) : (
          <NoDataContainer>
            <Typography
              variant="body1"
              color="gray"
              sx={{ px: 2, textAlign: "center" }}
            >
              {selectedPhase
                ? type?.val === "surveyPackage"
                  ? "No surveys linked. Add a survey to this package."
                  : `No forms added. This ${emptyEntityLabel} cannot be assigned to participants until a form is added.`
                : "No Data"}
            </Typography>
          </NoDataContainer>
        )}
      </Box>
    </Box>
  );
};

export default Forms;
